import { getHostname } from '../utils/location';

const PROD = 'prod';
const QA = 'qa';
const DEV = 'dev';
const LOCAL = 'local';

/**
 * Get the environment based on the hostname.
 * @returns {string} - The environment.
 */
function getEnv(): string {
  const hostname = getHostname();
  if (hostname.includes('fabfitfun')) {
    return PROD;
  }
  if (hostname.includes('fff-qa')) {
    return QA;
  }
  if (hostname.includes('local')) {
    return LOCAL;
  }
  return DEV;
}

/**
 * Get the hostname based on the environment.
 * @returns {string} - The hostname.
 */
function getHostName(): string {
  const env = getEnv();
  switch (env) {
    case PROD:
      return 'fabfitfun';
    case QA:
      return 'fff-qa';
    case DEV:
      return 'fff-dev';
    default:
      return 'fff-dev';
  }
}

export { getEnv, getHostName };
